// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"a8d756e5","769":"cc365600"}[chunkId] + ".chunk.js";
};